interface ICiStatusBadgeProps {
  /** `success` / `failure` / `pending` / `unknown` — codegen widens this to plain `string`. */
  conclusion: string;
  successCount: number;
  failureCount: number;
  cancelledCount: number;
  pendingCount: number;
  totalCount: number;
}

/**
 * Compact CI status pill for the pending-release header. Three visual states
 * (success / failure / other) tinted from the semantic-status palette so the
 * operator can read it at a glance without parsing the counts.
 */
const CiStatusBadge = ({
  conclusion,
  successCount,
  failureCount,
  cancelledCount,
  pendingCount,
  totalCount,
}: ICiStatusBadgeProps) => {
  const counts = `${successCount}/${totalCount} ✓`;
  // Leads with failures, unlike `summarizeCommitCi`, which ranks pending first — with both
  // present the pill reads neutral while the detail names the failing checks.
  const detail =
    failureCount > 0
      ? `${failureCount} failing`
      : pendingCount > 0
        ? `${pendingCount} pending`
        : cancelledCount > 0
          ? `${cancelledCount} cancelled`
          : totalCount === 0
            ? 'no checks'
            : 'all green';
  if (conclusion === 'success') {
    return (
      <span className="border-border-success_subtle text-fg-success-primary inline-flex items-center gap-2 border px-2 py-0.5 text-xs uppercase tracking-wide">
        <span className="bg-fg-success-primary inline-block h-1.5 w-1.5 rounded-full" />
        CI {counts} · {detail}
      </span>
    );
  }
  if (conclusion === 'failure') {
    return (
      <span className="border-border-error_subtle text-fg-error-primary inline-flex items-center gap-2 border px-2 py-0.5 text-xs uppercase tracking-wide">
        <span className="bg-fg-error-primary inline-block h-1.5 w-1.5 rounded-full" />
        CI {counts} · {detail}
      </span>
    );
  }
  return (
    <span className="border-border-secondary text-fg-secondary inline-flex items-center gap-2 border px-2 py-0.5 text-xs uppercase tracking-wide">
      <span className="bg-fg-tertiary inline-block h-1.5 w-1.5 rounded-full" />
      CI {counts} · {detail}
    </span>
  );
};

export default CiStatusBadge;
